import React from 'react';
import { FileText, AlertTriangle, CheckCircle } from 'lucide-react';

const ExpirationStatisticsCard = ({ title, statistics }) => {
  const getIcon = (key) => {
    if (key === 'expired' || key === 'critical' || key === 'warning') {
      return <AlertTriangle className="h-5 w-5 text-orange-500" />;
    }
    if (key === 'valid') {
      return <CheckCircle className="h-5 w-5 text-green-500" />;
    }
    return <FileText className="h-5 w-5 text-blue-500" />;
  };

  const formatLabel = (key) => {
    const labels = {
      workPermit: 'Work Permits',
      visa: 'Visas',
      driverLicense: 'Driver Licenses',
      passport: 'Passports',
      expired: 'Expired',
      critical: 'Critical (≤7 days)',
      warning: 'Warning (≤14 days)',
      upcoming: 'Upcoming (≤30 days)',
      valid: 'Valid',
      total: 'Total Documents'
    };
    return labels?.[key] || key;
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">{title}</h3>
      <div className="space-y-3">
        {statistics && Object.entries(statistics)?.map(([key, value]) => (
          <div key={key} className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              {getIcon(key)}
              <span className="text-sm text-gray-600">{formatLabel(key)}</span>
            </div>
            <span className="text-lg font-semibold text-gray-900">{value || 0}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExpirationStatisticsCard;